import { motion } from "framer-motion";
import { IMAGES } from "@/lib/assets";
import { useLang } from "@/lib/i18n";

const chapterNums = ["01", "02", "03"];

export default function Manifesto() {
  const { t } = useLang();
  const chapters = chapterNums.map((n, i) => ({ n, ...t.manifesto.chapters[i] }));
  return (
    <section className="relative py-28 md:py-40 border-b border-white/10 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={IMAGES.runner} alt="" className="w-full h-full object-cover grayscale opacity-20" />
        <div className="absolute inset-0 bg-[#0A0A0A]/80" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <p className="font-mono-pw uppercase text-xs tracking-[0.3em] text-[#E6FF00] mb-16">{t.manifesto.overline}</p>

        <div className="space-y-16 md:space-y-24">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-120px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-${c.n}`}
              className="flex flex-col md:flex-row gap-4 md:gap-10 md:items-baseline"
            >
              <span className="font-mono-pw text-[#E6FF00] text-sm tracking-[0.2em] md:pt-4 shrink-0">{c.n}</span>
              <h3 className="font-anton uppercase leading-[0.9] text-4xl md:text-7xl lg:text-8xl">
                <span className="text-white">{c.lead} </span>
                <span className="pw-outline-white">{c.rest}</span>
              </h3>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-20 md:mt-28 font-body text-white/60 text-lg md:text-xl max-w-2xl leading-relaxed"
        >
          {t.manifesto.closing}
        </motion.p>
      </div>
    </section>
  );
}
